<template>
  <div class="container">
    <Header @change="menuChange" @changeType="moduleChange"/>
    <div class="controller-content">
        <component :is="showComponent" :modeuleType="modeuleType"></component>
    </div>
  </div>
</template>
<script>
import Header from "./header/header.vue";
import DeviceDebug from './components/deviceDebug.vue'
export default {
  components: {
    Header,
    DeviceDebug
  },
  data() {
    return {
        showComponent:'DeviceDebug',
        modeuleType:{}
    };
  },
  created() {
    this.DPC = this.$Core.getProvider("DPC");
    console.log(this.DPC);
  },
  methods:{
    menuChange(evt){

    },
    moduleChange(evt){
      console.log(evt)
      this.modeuleType = evt
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  background: rgba(237, 237, 237, 1);
  color: #515151;
  height: 100%;
  width: 100%;
  border-radius: 15px;
  overflow: hidden;
  .controller-content {
    background: #fff;
    height: calc(100% - 43px);
    width: 100%;
    position: relative;
    box-shadow: 0px -4px 10px  rgba(0, 0, 0, 0.05);
    z-index: 15;
  }
}
</style>